// extracted by mini-css-extract-plugin
module.exports = {"geoButton":"Xv6A5q","selected":"_3SWd34"};